var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"card-head",attrs:{"slot":"header"},slot:"header"},[_c('div',[_vm._v("使用说明")])]),_c('PdfViewer',{attrs:{"url":"/static/瑞家园管理系统操作手册(工厂端).pdf","height":500}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }